import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RecordService } from '../../services/record.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoadingService } from '../../services/util/loading.service';

import * as moment from 'moment';

export interface UsersData {
  name: string;
  id: number;
}

@Component({
  selector: 'app-assignAppointmentRecord',
  templateUrl: './assignAppointmentRecord.component.html',
  styleUrls: ['./assignAppointmentRecord.component.css']
})
export class AssignAppointmentRecordComponent {

  action: string;
  appointment: any;
  panelOpenState = false;
  gender: any;
  docNumber: any;

  person: any;
  dateFrom: any;
  maxDate: any = new Date();
  mailValid: boolean;
  numberOfPersons: any;

  constructor(
    public dialogRef: MatDialogRef<AssignAppointmentRecordComponent>,
    private recordService: RecordService,
    private snackBar: MatSnackBar,
    private loadingService: LoadingService,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: UsersData) {

    this.appointment = { ...data };

  }

  closeDialog() {
    this.dialogRef.close({ event: 'Cancel' });
  }


  snackBarMessage(msg: any, duration: any) {
    this.snackBar.open(msg, '', {
      duration: duration, panelClass: ['blue-snackbar']
    });
  }

  validEmail() {
    if (this.person.email) {
      const regex = new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/ig);
      const test = regex.test(this.person.email);
      this.mailValid = test ? true : false;
    }
  }

  availableDays() {
    const dateFrom = this.dateFrom ? moment(this.dateFrom).format('YYYY-MM-DD') : '';
    this.recordService.getNumberOfPersonbyDay(this.appointment.officeId, dateFrom).subscribe((response: any) => {
      this.numberOfPersons = response;
    }, (e: any) => {
      if (e.status === 409) {
        this.snackBarMessage(e.error.message, 5000);
      } else {
        this.snackBarMessage('Ocurrio un problema', 5000);
      }
    });
  }

  assign() {
    this.appointment.dateFrom = this.dateFrom;
    if (this.dateFrom) {
      this.loadingService.enableShowPageSpinner();
      this.recordService.confirmCertificateAppointment(this.appointment.id, this.appointment).subscribe((response: any) => {
        this.snackBarMessage('Se generó el turno exitosamente', 5000);

        this.dialogRef.close({ event: 'Accept' });
      }, (e: any) => {
        if (e.status === 409) {
          this.snackBarMessage(e.error.message, 5000);
        } else {
          this.snackBarMessage('Ocurrió un problema', 5000);
        }
      });
    } else {
      this.snackBarMessage('Debe elegir una fecha', 5000);
    }

  }
}
